import classNames from 'classnames';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useResponsive } from '../../../../hooks/use_responsive';
import { useUser } from '../../../../hooks/use_user';
import { SignupLoginModalActions } from '../../../../redux/signup_login_modal';
import { ActiveMapPageModalType } from '../../../../routes/map_page/lib/map_page_types';
import SvgAddWaypointIcon from '../../../svg/add_waypoint_icon';
import SvgMap from '../../../svg/map';
import styles from './layers_quick_toggle_menu.less';

interface LayersQuickToggleMenuProps {
  activeModal: ActiveMapPageModalType;
  isWaypointCreateMode: boolean;
  onModalChange: (shouldOpen: boolean, type: ActiveMapPageModalType) => void;
  onWaypointCreate: () => void;
}
export const LayersQuickToggleMenu = (props: LayersQuickToggleMenuProps) => {
  const { activeModal, isWaypointCreateMode, onModalChange, onWaypointCreate } = props;

  const legendSelected = activeModal === 'legend';

  const { isDesktop } = useResponsive();
  const { user } = useUser();
  const dispatch = useDispatch();

  return (
    <>
      <div className={styles.legendWrapper}>
        <span
          className={classNames(styles.legend, {
            [styles.legend__selected]: legendSelected,
          })}
          onClick={(e) => {
            e.stopPropagation();
            onModalChange(true, 'legend');
          }}
        >
          <SvgMap />
        </span>
      </div>

      {isDesktop && (
        <div className={styles.waypointCreateButton}>
          <span
            onClick={(e) => {
              e.stopPropagation();
              if (!user) {
                dispatch(
                  SignupLoginModalActions.SIGNUP_LOGIN_MODAL_OPEN({
                    heading: 'To Create Waypoints Sign Up or Log In',
                  })
                );

                return;
              }
              if (isWaypointCreateMode) {
                return;
              }
              onWaypointCreate();
              if (activeModal === 'waypoints') {
                return;
              }
              onModalChange(true, 'waypoints');
            }}
          >
            <SvgAddWaypointIcon />
          </span>
        </div>
      )}
    </>
  );
};
